import React, { useEffect, useState } from "react";
import { Select, MenuItem } from "@mui/material";
import { myYouthService } from "../services/api/my-youth.service";

interface SelectGroupProps {
  onProgramChange: (value: string) => void;
  onYouthChange: (value: string) => void;
}

const YouthSelectGroup: React.FC<SelectGroupProps> = ({
  onProgramChange,
  onYouthChange,
}) => {
  const [selectedProgram, setSelectedProgram] = useState("");
  const [selectedYouth, setSelectedYouth] = useState("");
  const [youthOptions, setYouthOptions] = useState<any[]>([]);
  const [programOptions, setProgramOptions] = useState<any[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const programsRes = await myYouthService.getDefaultEnrolledPrograms();
      setProgramOptions(programsRes.data.programs);

      const youthRes = await myYouthService.getYouthRequests();
      setYouthOptions(youthRes.data.requests);
    } catch (error) {
      console.error("Failed to fetch data", error);
    }
  };

  const handleProgramChange = (value: string) => {
    setSelectedProgram(value);
    onProgramChange(value);
  };

  const handleYouthChange = (value: string) => {
    setSelectedYouth(value);
    onYouthChange(value);
  };

  return (
    <div className="flex items-start justify-start gap-16">
      <div className="w-1/3">
        <Select
          displayEmpty
          size="small"
          required
          value={selectedProgram}
          onChange={(e) => handleProgramChange(e.target.value as string)}
          className="w-full"
        >
          <MenuItem value="" disabled>
            Select Program
          </MenuItem>
          {programOptions.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div className="w-1/3">
        <Select
          displayEmpty
          size="small"
          required
          value={selectedYouth}
          onChange={(e) => handleYouthChange(e.target.value as string)}
          className="w-full"
        >
          <MenuItem value="" disabled>
            Select Youth
          </MenuItem>
          {youthOptions.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {`${option.firstName} ${option.lastName}`}
            </MenuItem>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default YouthSelectGroup;
